import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';

const IconButton = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { variant , outline , disabled , onClick , className , children  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "variant",
        "outline",
        "disabled",
        "onClick",
        "className",
        "children"
    ]);
    if (!children) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("button", swcHelpers.extends({}, rest, {
        className: classnames('icon-button', {
            'icon-button--outline': outline && !variant,
            [`icon-button--${variant}`]: variant
        }, className),
        onClick: onClick,
        disabled: disabled || false,
        ref: ref,
        type: "button"
    }), children);
});
IconButton.displayName = 'IconButton';

export { IconButton as default };
//# sourceMappingURL=IconButton.js.map
